module.exports = __webpack_public_path__ + "5123d80331f32013e5a3dc95705cf6b3.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/icons/wallet.png
// module id = 622
// module chunks = 0